import GoApi from "@/libs/client/goApi/goApi";

export const getSearchRecommended = async () => {
  try {
    const response = await GoApi.flight.getDestinationsRecommended();
    if (response.status && response.data) {
      return response.data;
    }
    return null;
  } catch (error) {
    return null;
  }
};
